import React from "react"
import { RaisedButton } from "material-ui"
import { EListCalendarViewModes } from "../../models"
import strings from "../../localization/strings"
interface IProps {
  viewMode: EListCalendarViewModes
  handleChange(viewMode: EListCalendarViewModes): void
}
const styles = {
  btn: { background: "white" },
  activeBtn: { background: "#F5F5F5" },
}

const ChooseListCalendarViewMode: React.SFC<IProps> = (props: IProps) => {
  return (
    <div>
      <RaisedButton
        data-intercom-target={"DateFilter-Btn-ListView"}
        label={strings.List_View.toUpperCase()}
        style={{ marginRight: 5 }}
        onTouchTap={() => props.handleChange(EListCalendarViewModes.ListView)}
        buttonStyle={props.viewMode === EListCalendarViewModes.ListView ? styles.activeBtn : styles.btn}
      />
      <RaisedButton
        data-intercom-target={"DateFilter-Btn-CalendarView"}
        label={strings.Calendar_View.toUpperCase()}
        style={{ marginRight: 5 }}
        onTouchTap={() => props.handleChange(EListCalendarViewModes.CalendarView)}
        buttonStyle={props.viewMode === EListCalendarViewModes.CalendarView ? styles.activeBtn : styles.btn}
      />
    </div>
  )
}

export default ChooseListCalendarViewMode